import { EditableSelect, EditableText, EditableNumber } from "ui-components/EditableInput2";
import dayjs from "dayjs";

export const formatDateTime = (value) => (value ? dayjs(value).format("DD/MM/YYYY HH:mm:ss") : "");

const userAndCreatedOnColumns = [
  {
    header: "User ID",
    accessorKey: "createdBy",
  },
  {
    header: "Created On",
    accessorKey: "createdOn",
    cell: ({ getValue }) => formatDateTime(getValue()),
    exportFormat: formatDateTime,
  },
];


export const physicalCountListcolumns = [
    // {
    //   header: "Physical Count No",
    //   accessorKey: "pCountNo",
    // },
    {
      header: "Zone ID",
      accessorKey: "zoneID",
    },
    {
      header: "Location ID",
      accessorKey: "locationID",
    },
    {
      header: "Carton Id",
      accessorKey: "cartonID",
    },
    // {
    //   header: "Customer Code",
    //   accessorKey: "customerCode",
    // },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    }, 
    {
      header: "SKU Description",
      accessorKey: "skuDescription",
    }, 
    {
      header: "Retail Barcode",
      accessorKey: "retailBarcode",
    },  
    {
      header: "Count Qty",
      accessorKey: "countQty",
      ...({ cell: EditableNumber }),
    },
    {
      header: "MLN",
      accessorKey: "mln",
    },
    {
      header: "Expiry Date",
      accessorKey: "expiryDate",
      cell: ({ row }) => {
        const dateValue = row.original.expiryDate;
        return dateValue
          ? new Date(dateValue).toLocaleDateString("en-GB") // Format to dd/MM/yyyy
          : "";
      },
      // cell: ({ getValue }) => {
      //   const dateValue = getValue();
      //   if (!dateValue) {
      //     return ""; // Return empty string if the expiry date is null or empty
      //   }
      //   const formattedDate = new Date(dateValue).toLocaleDateString(); // Format the date to "DD/MM/YYYY" or based on the user's locale
      //   return formattedDate;
      // },
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ getValue }) => {
        const statusValue = getValue();
        if (statusValue === "P") {
          return "Complete Scanning";
        } else if (statusValue === "O") {
          return "In Scanning";
        } else if (statusValue === "C") {
          return "Data Uploaded";
        }
        return statusValue; // Return the original value if it's not "P" or "O"
      },
    },
    ...userAndCreatedOnColumns,
  ];

  export const physicalCountListLookup = [
    // {
    //   header: "Physical Count No",
    //   accessorKey: "pCountNo",
    // },
    {
      header: "Zone ID",
      accessorKey: "zoneID",
    },
    {
      header: "Location ID",
      accessorKey: "locationID",
    },
    {
      header: "Carton Id",
      accessorKey: "cartonID",
    },
    // {
    //   header: "Customer Code",
    //   accessorKey: "customerCode",
    // },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    }, 
    {
      header: "System Qty",
      accessorKey: "sysQty",
    },
    {
      header: "Count Qty",
      accessorKey: "countQty",
    },
    {
      header: "Variance",
      accessorKey: "variance",
    },
    {
      header: "MLN",
      accessorKey: "mln",
    },
    {
      header: "Expiry Date",
      accessorKey: "expiryDate",
      cell: ({ getValue }) => {
        const dateValue = getValue();
        if (!dateValue) {
          return ""; // Return empty string if the expiry date is null or empty
        }
        const formattedDate = new Date(dateValue).toLocaleDateString("en-GB"); // Format the date to "DD/MM/YYYY" or based on the user's locale
        return formattedDate;
      },
    },
    // {
    //   header: "Retail Barcode",
    //   accessorKey: "retailBarcode",
    // },
    
    ...userAndCreatedOnColumns,
  ];

  export const latestCountListcolumns = [
    // {
    //   header: "Physical Count No",
    //   accessorKey: "pCountNo",
    // },
    {
      header: "Zone ID",
      accessorKey: "zoneID",
    },
    {
      header: "Location ID",
      accessorKey: "locationID",
    },
    {
      header: "Carton Id",
      accessorKey: "cartonID",
    },
    {
      header: "Vendor Code",
      accessorKey: "vendorCode",
      //...{ cell: (props) => EditableSelect({ ...props,options:vendorOptions}) },
    },
    {
      header: "SKU Code",
      accessorKey: "skuCode",
    }, 
    {
      header: "Sys Qty",
      accessorKey: "sysQty",
    },
    {
      header: "Count Qty",
      accessorKey: "phyQty",
      ...({ cell: EditableNumber }),
    },
    {
      header: "Variance",
      accessorKey: "variance",
    },
    {
      header: "MLN",
      accessorKey: "mln",
    },
    {
      header: "Expiry Date",
      accessorKey: "expiryDate",
      cell: ({ getValue }) => {
        const dateValue = getValue();
        if (!dateValue) {
          return ""; // Return empty string if the expiry date is null or empty
        }
        const formattedDate = new Date(dateValue).toLocaleDateString("en-GB"); // Format the date to "DD/MM/YYYY" or based on the user's locale
        return formattedDate;
      },
    },
    {
      header: "Retail Barcode",
      accessorKey: "retailBarcode",
    },
  ];